import { useQuery } from "@tanstack/react-query";

import { certificateKeys } from "../../../redux/services/certificateKeys";

import { getCertificateAPICall } from "./utils.api";

export const useGetCertificate = (params) =>
  useQuery({
    queryKey: certificateKeys.getAllCertificate(params),
    queryFn: () => getCertificateAPICall(params),
  });